module.exports = __webpack_public_path__ + "static/callsheets_mobile@3x-83174a86022d0e88a492213821de1cb8.png";